// extracted by mini-css-extract-plugin
export default {"seoContent":"seoContent__YTNiM","seoContentBlock":"seoContentBlock__YzMyM","seoEntry":"seoEntry__YTNmO"};